import { Component, inject, input, type InputSignal, type Signal, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { type MatMenu, MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import type { ItemInfo } from '@core/models/navigation-item.model';
import { isAllSubItemsRequireUpgrade, isUpgradeRequired } from '@helpers/is-nav-item-need-upgrade';
import { WrapFnPipe } from '@shared/pipes/wrapFn.pipe';

import { CompanyTypeBasedRoutePipe } from '../../pipes/company-type-based-route.pipe';
import { CustomEventService } from '../../repository/customEvent.service';
import { handleNavigationClick } from '../nav-helpers';
import { UmeLockIconComponent } from '../ume-lock-icon/ume-lock-icon.component';

@Component({
  selector: 'ume-main-nav-menu-panel',
  templateUrl: './main-nav-menu-panel.component.html',
  styleUrls: ['./main-nav-menu-panel.component.scss'],
  imports: [
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    RouterLinkActive,
    CompanyTypeBasedRoutePipe,
    RouterLink,
    WrapFnPipe,
    UmeLockIconComponent,
  ],
})
export class MainNavMenuPanelComponent {
  protected readonly isUpgradeRequired = isUpgradeRequired;
  protected readonly isAllSubItemsRequireUpgrade = isAllSubItemsRequireUpgrade;

  private readonly router: Router = inject(Router);
  private readonly customEventService: CustomEventService = inject(CustomEventService);

  public items: InputSignal<ItemInfo[]> = input.required();

  menu: Signal<MatMenu> = viewChild.required('menu');

  public handleClick(item: ItemInfo, event: MouseEvent): void {
    handleNavigationClick(item, event, this.router, this.customEventService);
  }
}
